import actionTypes from '../constants/action-types';

const setSupportedLocales = (locales) => ({
  type: actionTypes.SET_SUPPORTED_LOCALES,
  payload: { locales },
});

export default setSupportedLocales;
